
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
interface EInvoiceInterface {
    _id?: string;
    irnResponse?: Response;
    irnCancellationResponse?: CancelResponse;
    AckNo?: number;
    AckDt?: string;
    Irn?: string;
    Version?: string;
    TranDtls?: any;
    DocDtls?: any;
    SellerDtls?: any;
    BuyerDtls: any;
    DispDtls?: any;   // Assuming this can be optional as it's not marked @NotNull
    ShipDtls?: any;   // Same assumption
    ItemList: any[];
    ValDtls?: any;
    PayDtls?: any;     // Same assumption
    RefDtls?: any;     // Same assumption
    AddlDocDtls?: any[]; // Same assumption
    ExpDtls?: any;     // Same assumption
    EwbDtls?: any;     // Same assumption
    cancelIRN?: any; // Same assumption
}
interface CancelResponse {
    Status: string;
    Data: {
        Irn: string;
        CancelDate: string;
    };
    ErrorDetails: ErrorDetails[];
    InfoDtls: InfoDetails[];

}
interface Response {
    Status: string;
    Data?: ResponseData;
    ErrorDetails?: ErrorDetails[];
    InfoDtls?: InfoDetails[];
}

interface ResponseData {
    AckNo: string;
    AckDt: string;
    Irn: string;
    SignedInvoice: string;
    SignedQRCode: string;
    Status: string;
    EwbNo: string;
    EwbDt: string;
    EwbValidTill: string;
    ExtractedSignedInvoiceData?: any;
    ExtractedSignedQrCode?: any;
    QrCodeImage: string;
    JwtIssuer: string;
}

interface ErrorDetails {
    ErrorCode: string;
    ErrorMessage: string;
}

interface InfoDetails {
    InfCd: string;
    Desc: Description;
}

interface Description {
    AckNo: number;
    AckDt: string;
    Irn: string;
}
interface CancelRequestBody {
    invoice_id: string | null;
    cnlRem: string | null;
    cnlRsn: string | null;
}
@Component({
    props: {
        value: {
            default: null,
        },
        readonly: {
            default: true,
        }
    },
})
export default class EInvoice extends Vue {
    @Prop({ default: null }) readonly invoice_id!: string | null;
    @Prop({ default: null }) readonly invoiceStatus!: number | null;

    eInvoice: EInvoiceInterface | null = null;
    generateErrorDialog = false;
    cancelErrorDialog = false;
    cancelPayload: CancelRequestBody = {
        invoice_id: null,
        cnlRem: null,
        cnlRsn: null
    };
    cancelPayloadDialog = false;
    cancelReasons = [
        { text: 'Duplicate', value: '1' },
        { text: 'Data entry mistake', value: '2' },
        { text: 'Order Cancelled', value: '3' },
        { text: 'Others', value: '4' },
    ];

    get shouldShowGenerateButton() {
        let Status = "0"
        if (this.eInvoice && this.eInvoice.irnResponse && this.eInvoice.irnResponse.Status) {
            Status = this.eInvoice.irnResponse.Status;
        }
        if (Status == "1") {
            return false;
        } else {
            return !!this.invoice_id;
        }
    }

    get shouldShowCancelButton() {
        let Status = "0"
        if (this.eInvoice && this.eInvoice.irnResponse && this.eInvoice.irnResponse.Status) {
            Status = this.eInvoice.irnResponse.Status;
        }
        const isCancelled = this.eInvoice && this.eInvoice.irnCancellationResponse && this.eInvoice.irnCancellationResponse.Data && this.eInvoice.irnCancellationResponse.Data.CancelDate;
        return Status == "1" && !isCancelled;
    }

    async detail(_id: string | null) {
        if (_id) {
            common.setLoading(true);
            try {
                const response: EInvoiceInterface = await doGet(`/api/e-invoice/${_id}/detail`);
                if (response) {
                    this.eInvoice = { ...response };
                }
            } catch (error) {
                console.log(error);
            } finally {
                common.setLoading(false);
            }
        }
    }

    @Watch("invoice_id", { immediate: true })
    onInvoiceIdChange(newId: string, oldId: string) {
        if (newId) {
            this.detail(newId);
        }

    }

    async generateIRN() {
        console.log(this.invoice_id);
        if (this.invoice_id) {
            common.setLoading(true);
            try {
                const response = await doGet(`/api/e-invoice/${this.invoice_id}/generate`);
                this.eInvoice = { ...response };
                console.log(this.eInvoice);
                if (this.eInvoice && this.eInvoice.irnResponse && this.eInvoice.irnResponse.Status) {
                    if (this.eInvoice.irnResponse.Status != "1") {
                        this.generateErrorDialog = true;
                    } else {
                        common.showMessage("E-Invoice Generated Successfully");
                    }
                }
            } catch (e) {
                if (typeof e == 'string') {
                    common.setError(e);
                }
            } finally {
                common.setLoading(false);
            }
        }
    }
    async cancelIRN() {
        if (this.invoice_id) {
            common.setLoading(true);
            try {
                if (this.cancelPayload) {
                    this.cancelPayload.invoice_id = this.invoice_id;
                    const response = await doPost(`/api/e-invoice/cancel`, this.cancelPayload);
                    this.eInvoice = { ...response };
                    this.cancelPayloadDialog = !this.cancelPayloadDialog;
                    let cancellationStatus = "0";
                    if (this.eInvoice && this.eInvoice.irnCancellationResponse && this.eInvoice.irnCancellationResponse.Status) {
                        cancellationStatus = this.eInvoice.irnCancellationResponse.Status;
                    }
                    if (cancellationStatus == "1") {
                        common.showMessage("E Invoice Cancelled Successfully");
                    } else {
                        this.cancelErrorDialog = true;
                    }
                }
            } catch (e) {
                if (typeof e == 'string') {
                    common.setError(e);
                } else {
                    common.setError("Error Occurred.");
                }
            } finally {
                common.setLoading(false);
            }
        }
    }

}
